import { Helmet } from "react-helmet-async";
import { Box, Typography, useTheme } from "@mui/material";
import { useState, useEffect } from "react";
import { APP_TITLE } from "../../constant/index.js";
import DashboardStats from "../../modules/Dashboard/DashboardStats.jsx";
import CandidateInterviewsTable from "../../modules/Dashboard/CandidateInterviewsTable.jsx";
import RescheduleInterviewDialog from "../../modules/Dashboard/RescheduleInterviewDialog.jsx";
import { AxiosService } from "../../services/axios/axiosService.js";
import toast from "react-hot-toast";

const Dashboard = () => {
  const theme = useTheme();
  const [rescheduleDialogOpen, setRescheduleDialogOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [interviewsData, setInterviewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInterviews = async () => {
      try {
        const response = await AxiosService.get("/api/interview");
        setInterviewsData(response);
      } catch (err) {
        console.error(err);
        // toast.error(
        //   err.message || "Oops! Something went wrong while retrieving the data."
        // );
      } finally {
        setLoading(false);
      }
    };

    fetchInterviews();
  }, []);

  const onReschedule = (candidateData) => {
    setSelectedCandidate(candidateData);
    setRescheduleDialogOpen(true);
  };

  const handleCloseReschedule = () => {
    setRescheduleDialogOpen(false);
    //setSelectedCandidate(null);
  };

  return (
    <>
      <Helmet>
        <title>Dashboard | {APP_TITLE}</title>
        <meta
          name="Dashboard"
          content="Dashboard to monitor interview progress and AI results"
        />
      </Helmet>

      <Box
        sx={{
          p: 3.5,
          backgroundColor: theme.palette.background.default,
          minHeight: "100vh",
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, color: theme.palette.text.primary,  }}
          >
            Dashboard
          </Typography>
        </Box>

        <DashboardStats interviewCount={interviewsData}/>

        <CandidateInterviewsTable
          interviews={interviewsData}
          loading={loading}
          onReschedule={onReschedule}
        />
      </Box>

      <RescheduleInterviewDialog
        open={rescheduleDialogOpen}
        onClose={handleCloseReschedule}
        candidateData={selectedCandidate}
      />
    </>
  );
};

export default Dashboard;
